import clsx from "clsx";

import "./PlanPicker.css";
import { StripePlanId } from "../../../lib/types";
import { PLANS } from "../../../lib/plans";

type Props = {
  selectedPlanId: StripePlanId;
  onSelect: (planId: StripePlanId) => void;
};

const PlanPicker = ({ selectedPlanId, onSelect }: Props) => (
  <div className="PlanPicker" role="radiogroup" aria-label="Choose your plan">
    {PLANS.map((plan) => {
      const selected = plan.planId === selectedPlanId;

      return (
        <button
          key={plan.planId}
          type="button"
          role="radio"
          aria-checked={selected}
          data-testid={`plan-card-${plan.planId}`}
          className={clsx("planCard", selected && "selected")}
          onClick={() => onSelect(plan.planId)}
        >
          {plan.bestValue && <span className="bestValueBadge">best value</span>}

          <span className="planInfo">
            <span className="planTitle">{plan.title}</span>
            <span className="planBilled">{plan.billedLabel}</span>
          </span>

          <span className="planMonthly">
            <span className="planMonthlyAmount">${plan.monthlyPrice}</span>
            <span className="planMonthlyUnit">/mo</span>
          </span>
        </button>
      );
    })}
  </div>
);

export default PlanPicker;
